import React from 'react'
import { DI } from 'modules'
import Component from 'components/component'
import AgreementModal from './agreement-modal'

export class AcceptAgreementsModals extends Component {
  static defaultProps = {
    onAccept() {},
    acceptOnly: false,
  }

  render() {
    const [agreement] = this.props.user.userAcceptingAgreements
    if (agreement) {
      return (
        <AgreementModal
          key={agreement.id}
          agreement={agreement}
          onAccept={this.props.onAccept}
          acceptOnly={this.props.acceptOnly}
        />
      )
    } else {
      return null
    }
  }
}

export default DI(['user'])(AcceptAgreementsModals)
